import { c as _c } from "react/compiler-runtime";
import useCartAddToCart from '@/contexts/cartContext/hooks/useCartAddToCart';
import { Button } from '@winelidays/wld-tsx-2/elements';
import TunnelTemplate from '../../components/TunnelTemplate';
const VoucherBooking = (t0) => {
    const $ = _c(14);
    const { experience } = t0;
    const addToCart = useCartAddToCart();
    let t1;
    if ($[0] !== addToCart || $[1] !== experience.identifier) {
        t1 = () => {
            const reservation = { bookableId: experience.identifier, remainingStock: { adults: 4 }, from: "me", to: "you", message: "Hello world" };
            addToCart(reservation);
        };
        $[0] = addToCart;
        $[1] = experience.identifier;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const tempHandleAddToCart = t1;
    let t2;
    if ($[3] !== experience.name) {
        t2 = <p>WIP booking detail {experience.name}</p>;
        $[3] = experience.name;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[5] !== tempHandleAddToCart) {
        t3 = <Button title="add to cart" className="btn-primary mt-4" onClick={tempHandleAddToCart}>Simulate add to cart

    </Button>;
        $[5] = tempHandleAddToCart;
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = <div className="tunnel-padding-x py-4 lg:!px-4">{t2}{t3}
    </div>;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <p>WIP CancellationInfo</p>;
        t6 = <p>WIP VoucherBookingForm</p>;
        $[10] = t5;
        $[11] = t6;
    }
    else {
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[12] !== t4) {
        t7 = <><TunnelTemplate loading={false} stickyContent={t4} className="!mb-0">{t5}{t6}

      </TunnelTemplate></>;
        $[12] = t4;
        $[13] = t7;
    }
    else {
        t7 = $[13];
    }
    return t7;
};
export default VoucherBooking;
